var _path, _path2, _g, _path3, _path4, _g2, _path5, _g3, _g4, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNominateUserEmptyState(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 66,
    viewBox: "0 0 64 66",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "Mask Group 2"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Ellipse 652",
    d: "M32 64C49.6731 64 64 49.6731 64 32C64 14.3269 49.6731 0 32 0C14.3269 0 0 14.3269 0 32C0 49.6731 14.3269 64 32 64Z",
    fill: "#EAECF0"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group",
    filter: "url(#filter0_d_223_3512)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Mask Group"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_223_3512",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 64,
    height: 64
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Ellipse 653",
    d: "M32 64C49.6731 64 64 49.6731 64 32C64 14.3269 49.6731 0 32 0C14.3269 0 0 14.3269 0 32C0 49.6731 14.3269 64 32 64Z",
    fill: "url(#paint0_linear_223_3512)"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_223_3512)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Rectangle 5615",
    d: "M50.3466 18.3467H13.6533C12.4751 18.3467 11.5199 19.3018 11.5199 20.48V65.28C11.5199 66.4582 12.4751 67.4133 13.6533 67.4133H50.3466C51.5248 67.4133 52.4799 66.4582 52.4799 65.28V20.48C52.4799 19.3018 51.5248 18.3467 50.3466 18.3467Z",
    fill: "white"
  }))))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Rectangle 5617",
    d: "M28.1599 22.6133H17.0666C16.3597 22.6133 15.7866 23.1864 15.7866 23.8933C15.7866 24.6003 16.3597 25.1733 17.0666 25.1733H28.1599C28.8668 25.1733 29.4399 24.6003 29.4399 23.8933C29.4399 23.1864 28.8668 22.6133 28.1599 22.6133Z",
    fill: "#EAECF0"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Rectangle 5620",
    d: "M28.1599 40.5333H17.0666C16.3597 40.5333 15.7866 41.1064 15.7866 41.8133C15.7866 42.5202 16.3597 43.0933 17.0666 43.0933H28.1599C28.8668 43.0933 29.4399 42.5202 29.4399 41.8133C29.4399 41.1064 28.8668 40.5333 28.1599 40.5333Z",
    fill: "#EAECF0"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Rectangle 5618"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M46.0798 29.0132H17.9198C16.9773 29.0132 16.2132 29.7773 16.2132 30.7199V34.9865C16.2132 35.9291 16.9773 36.6932 17.9198 36.6932H46.0798C47.0224 36.6932 47.7865 35.9291 47.7865 34.9865V30.7199C47.7865 29.7773 47.0224 29.0132 46.0798 29.0132Z",
    stroke: "#98A2B3",
    strokeWidth: 0.711111
  }))), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "Rectangle 5619",
    d: "M46.0799 46.5067H17.9199C16.7417 46.5067 15.7866 47.4618 15.7866 48.64V52.0533C15.7866 53.2315 16.7417 54.1867 17.9199 54.1867H46.0799C47.2581 54.1867 48.2133 53.2315 48.2133 52.0533V48.64C48.2133 47.4618 47.2581 46.5067 46.0799 46.5067Z",
    fill: "#EAECF0"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "Group 26781"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Ellipse 654",
    d: "M22.6133 13.6533C23.5559 13.6533 24.32 12.8892 24.32 11.9467C24.32 11.0041 23.5559 10.24 22.6133 10.24C21.6707 10.24 20.9066 11.0041 20.9066 11.9467C20.9066 12.8892 21.6707 13.6533 22.6133 13.6533Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Ellipse 655",
    d: "M32.0001 13.6534C32.9426 13.6534 33.7067 12.8893 33.7067 11.9468C33.7067 11.0042 32.9426 10.2401 32.0001 10.2401C31.0575 10.2401 30.2934 11.0042 30.2934 11.9468C30.2934 12.8893 31.0575 13.6534 32.0001 13.6534Z",
    fill: "#98A2B3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Ellipse 656",
    d: "M41.3868 13.6534C42.3293 13.6534 43.0934 12.8893 43.0934 11.9468C43.0934 11.0042 42.3293 10.2401 41.3868 10.2401C40.4442 10.2401 39.6801 11.0042 39.6801 11.9468C39.6801 12.8893 40.4442 13.6534 41.3868 13.6534Z",
    fill: "white"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "Group 26782"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Ellipse 658",
    d: "M36.6935 37.5468C37.8717 37.5468 38.8268 36.5916 38.8268 35.4134C38.8268 34.2352 37.8717 33.2801 36.6935 33.2801C35.5152 33.2801 34.5601 34.2352 34.5601 35.4134C34.5601 36.5916 35.5152 37.5468 36.6935 37.5468Z",
    fill: "#EAECF0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path 25916",
    d: "M38.3604 44.5315C38.0191 44.5315 37.7004 44.5315 37.4102 44.5131C37.0529 44.4889 36.7091 44.3667 36.4167 44.1597C36.1243 43.9528 35.8947 43.6692 35.7531 43.3402L33.953 39.7827C33.8209 39.6289 33.755 39.4293 33.7696 39.2271C33.7841 39.025 33.8779 38.8369 34.0306 38.7036C34.1557 38.6031 34.3117 38.549 34.4722 38.5504C34.5904 38.5539 34.7064 38.5829 34.8122 38.6355C34.9181 38.6881 35.0112 38.763 35.0853 38.8551L35.9028 39.9708L35.9152 39.9853V35.7464C35.9152 35.5361 35.9987 35.3344 36.1475 35.1857C36.2962 35.037 36.4979 34.9534 36.7082 34.9534C36.9185 34.9534 37.1202 35.037 37.2689 35.1857C37.4176 35.3344 37.5011 35.5361 37.5011 35.7464V38.5197C37.4919 38.4177 37.5041 38.3148 37.5368 38.2177C37.5695 38.1206 37.6221 38.0314 37.6913 37.9558C37.7604 37.8801 37.8445 37.8197 37.9383 37.7784C38.032 37.7371 38.1334 37.7157 38.2358 37.7157C38.3383 37.7157 38.4397 37.7371 38.5334 37.7784C38.6272 37.8197 38.7113 37.8801 38.7804 37.9558C38.8495 38.0314 38.9022 38.1206 38.9349 38.2177C38.9676 38.3148 38.9798 38.4177 38.9706 38.5197V39.0979C38.9614 38.9958 38.9735 38.893 39.0062 38.7959C39.039 38.6988 39.0916 38.6095 39.1607 38.5339C39.2298 38.4583 39.314 38.3978 39.4077 38.3565C39.5015 38.3152 39.6028 38.2938 39.7053 38.2938C39.8078 38.2938 39.9091 38.3152 40.0029 38.3565C40.0966 38.3978 40.1807 38.4583 40.2499 38.5339C40.319 38.6095 40.3716 38.6988 40.4043 38.7959C40.4371 38.893 40.4492 38.9958 40.44 39.0979V39.5433C40.4308 39.4412 40.4429 39.3384 40.4757 39.2413C40.5084 39.1442 40.561 39.055 40.6301 38.9793C40.6993 38.9037 40.7834 38.8433 40.8772 38.802C40.9709 38.7606 41.0723 38.7393 41.1747 38.7393C41.2772 38.7393 41.3785 38.7606 41.4723 38.802C41.5661 38.8433 41.6502 38.9037 41.7193 38.9793C41.7884 39.055 41.841 39.1442 41.8738 39.2413C41.9065 39.3384 41.9187 39.4412 41.9094 39.5433V42.2471C41.8949 43.0787 41.519 44.4807 40.1968 44.4807C40.1008 44.485 39.2876 44.5319 38.3621 44.5319L38.3604 44.5315Z",
    fill: "#98A2B3",
    stroke: "white",
    strokeWidth: 0.355556
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_223_3512",
    x: 9.38659,
    y: 15.1467,
    width: 45.2267,
    height: 49.92,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: -1.06667
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.06667
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.788235 0 0 0 0 0.803922 0 0 0 0 0.85098 0 0 0 0.349 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_223_3512"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_223_3512",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_223_3512",
    x1: 32,
    y1: 0,
    x2: 32,
    y2: 64,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E3ECFA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DAE7FF"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNominateUserEmptyState);
export default __webpack_public_path__ + "static/media/nominate-user-empty-state.29dddb3269cdaa6f6fede4a2cc6c30ed.svg";
export { ForwardRef as ReactComponent };